<!-- Component that implements the search and visualization of documents -->
<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Alocar bolsa para projeto'"></basic-toolbar>
          <v-card-text>
            <v-container>
              <v-form v-model="formularioValido" ref="form">
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12>
                      <v-text-field
                        label='Projeto'
                        :value="projeto.titulo"
                        readonly
                        max-height="400">
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-space-between>
                    <v-flex sm9 xs11>
                      <v-select
                        label='Bolsa'
                        :items="listaBolsas"
                        v-model="idBolsa"
                        item-text="descricao"
                        item-value="idBolsa"
                        prepend-icon="dashboard"
                        max-height="400"
                        required
                        autocomplete
                        :rules="regrasBasicas" >
                      </v-select>
                    </v-flex>

                    <v-flex sm2 xs11>
                      <v-text-field
                        label='Quantidade'
                        v-model="quantidadeBolsas"
                        max-height="400"
                        required
                        :rules="regrasBasicas" >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
              </v-form>
            </v-container>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="confirmar" :disabled="!formularioValido">Alocar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import bolsas from '@/utils/bolsas'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  props: ['idProjeto'],
  data: () => ({
    projeto: {},
    listaBolsas: [],
    idBolsa: undefined,
    quantidadeBolsas: 1,
    formularioValido: false,
    regrasBasicas: [
      (input) => !!input || 'Este campo é obrigatório'
    ]
  }),
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    confirmar () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Alocando bolsa.' })
      bolsas.putAlocacao(this.idBolsa, this.idProjeto, this.quantidadeBolsas)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: 'Alocação feita com sucesso!'})
        this.$router.push({name: 'BolsasProjeto', params: {idProjeto: this.idProjeto}})
      })
      .catch(error => {
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Alocando bolsa.' })
      })
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' })
    bolsas.getBolsasGerenciadas()
    .then(response => {
      this.listaBolsas = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' })
    })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
    projetos.getProjeto(this.idProjeto)
    .then(response => {
      this.projeto = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// alocar-bolsa.vue?07989cac